import Logo from '../components/Logo.js';
import NavBar from '../components/NavBar.js';
import Footer from '../components/Footer.js';

import React from 'react';
import styled from 'styled-components';

const Page = styled.div`
position:relative;
min-height:100vh;
padding-bottom:300px;
`
const Title = styled.h2`
margin: 20px;
`
const H5 = styled.h5`
margin: 30px;
`

const Ul = styled.ul`
margin: 20px;
padding-left: 20px;
`

const MAIL = styled.img`
margin-bottom:-2px;
width:16px;
`

const Accueil = () => {
    return (
        <Page>
            <Logo/>
            <NavBar/>
            <Title>Théatra - Les données</Title>
            <H5>Outils de gestion des données pour le site <a href="https://theatra.mom.fr" target="_blank" rel="noreferrer">theatra.mom.fr</a></H5>
            <Ul>
                <li>Les notices sont créées et modifiées à partir du groupe zotero theatra</li>
                <li>Les photos de théatres sont stockées en local puis envoyées et diffusées par le service Nakala</li>
                <li>Les informations sur les théâtres sont saisies par cette interface ainsi que
                    les mots clefs de type synthèse, thème ou référence
                </li>
            </Ul>
            <p>Ce site est développé et hébergé à la MOM par le <a href="https://www.mom.fr/les-services-de-la-federation/pole-systeme-d-information-et-reseaux/presentation" target="_blank" rel="noreferrer">PSIR</a>.
            <br/>Pour plus d'information n'hésister pas à nous contacter <a href="mailto:psir@mom.fr"><MAIL src="/img/email.png"></MAIL></a></p>
            <Footer/>
        </Page>
    )
}
export default Accueil